import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="28" height="28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9.334 18.667l2.333-7 7-2.334-2.333 7-7 2.334z" /><path d="M14 24.5c5.799 0 10.5-4.701 10.5-10.5S19.799 3.5 14 3.5 3.5 8.201 3.5 14 8.201 24.5 14 24.5z" /></svg>;